import { Box, Tooltip } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { getProductStatus, ProductStatusBadge } from 'componentsV2';
import { getStockInfo } from 'pages/products/components/products-list/useProductColumns/contents/stock-info';
import { MobileProductCardProps } from '../../..';

export const Statuses = ({
  product
}: Pick<MobileProductCardProps, 'product'>) => (
  <Box display="flex" alignItems="center" gridGap={6}>
    {!!product?.isStockProduct && (
      <Tooltip arrow title="This product can be restocked quickly.">
        <ProductStatusBadge>
          <SText size="xs" title="Stock" />
        </ProductStatusBadge>
      </Tooltip>
    )}

    <ProductStatusBadge>
      <SText size="xs" title={getProductStatus(product)} />
    </ProductStatusBadge>
    {!!product?.stockInfo && (
      <ProductStatusBadge>
        <SText size="xs" title={getStockInfo(product?.stockInfo)} />
      </ProductStatusBadge>
    )}
  </Box>
);
